import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const ListItemWrap = styled(Box)(({ py }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: `${py || 0.2}rem 16px`,
    borderBottom: '1px solid #f0f2f5',
    transition: 'background-color 0.2s ease',
    '&:last-child': {
        borderBottom: 'none',
    },
    '&:hover': {
        backgroundColor: '#f8f9fa',
    },
}));

export const StatusDot = styled(Box)(({ bgcolor }) => ({
    width: '8px',
    height: '8px',
    flexShrink: 0,
    marginRight: '16px',
    borderRadius: '50%',
    backgroundColor: bgcolor || '#adb5bd',
}));